import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { BehaviorSubject, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { FeedbackContext, FeedbackMessage, FeedbackService, FeedbackVariant } from '@app/core/services';
import { NgForKeyDirective } from '../../directives/ng-for-track-by-id.directive';

@Component({
    selector: 'sl-feedback-panel',
    templateUrl: './feedback-panel.component.html',
    styleUrls: ['./feedback-panel.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgIf,
        NgFor,
        NgForKeyDirective,
        MatButtonModule,
        MatIconModule,
        AsyncPipe,
    ],
})
export class FeedbackPanelComponent {
	@Input() context: FeedbackContext;
	@Input() variant: FeedbackVariant;

	public items$ = new BehaviorSubject<FeedbackMessage[]>([]);
	public expanded = false;

	public messageTotal$ = this.items$.pipe(
		map((items) => items.filter(({ variant, context }) => variant === this.variant && context === this.context).length)
	);

	private readonly destroy$ = new Subject();

	constructor(private readonly feedback: FeedbackService) {
		this.feedback.messages$.pipe(takeUntil(this.destroy$)).subscribe((items: FeedbackMessage[]) => {
			this.items$.next(items.filter(({ variant, context }) => variant === this.variant && context === this.context));
		});
	}

	clear(id: string): void {
		// Close panel if clearing one error or all errors.
		if (this.items$.value.length === 1 || !id) {
			this.expanded = false;
		}

		this.feedback.clear(id, this.variant, this.context);
	}

	expand(): void {
		this.expanded = true;
	}
}
